import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { Search } from './models/search';

@Injectable({
  providedIn: 'root',
})
export class SearchesService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);
  private readonly userService = inject(UserService);

  getSearches(): Observable<Search[]> {
    return this.http
      .get<Search[]>(`${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/searches`)
      .pipe(map((searches) => searches.sort((a, b) => (a.searchDate > b.searchDate ? -1 : 1))));
  }

  postSearch(search: Search): Observable<Search> {
    return this.http.post<Search>(`${this.apiService.API_URL}/patrons/${search.userId}/searches`, search);
  }

  deleteSearch(searchId: number): Observable<Search> {
    return this.http.delete<Search>(`${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/searches/${searchId}`);
  }

  getSearchHistory(): Observable<Search[]> {
    return this.http.get<Search[]>(`${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/searches/history`);
  }

  postSavedSearchToHistory(search: Search): Observable<Search> {
    return this.http.post<Search>(`${this.apiService.API_URL}/patrons/${search.userId}/searches/history`, search);
  }
}
